import { UserDataObjType } from "../../types";
import { AxiosRequest } from "../common/axios-request";
import {
  CREATE_USER,
  DATA_RETENTION_CHECK,
  DATA_RETENTION_CHOICE,
  DELETE_USER,
  GET_ALL_USER_LIST,
  GET_ROLES,
  GET_USER_DETAILS,
  UPDATE_DEFAULT_FACILITY,
  UPDATE_USER,
  UPDATE_USER_PASSWORD,
} from "../common/constant";

const AddUser = (payload: UserDataObjType) => {
  return AxiosRequest.post(CREATE_USER, payload);
};

const GetAllUsersList = () => {
  return AxiosRequest.get(GET_ALL_USER_LIST);
};

const SingleUser = (id: string) => {
  return AxiosRequest.get(GET_USER_DETAILS.replace(":id", id));
};

const UpdateUser = (id: string, payload: UserDataObjType) => {
  return AxiosRequest.put(UPDATE_USER.replace(":id", id), payload);
};

const DeleteUser = (id: string) => {
  return AxiosRequest.delete(DELETE_USER.replace(":id", id));
};

const UserRoles = () => {
  return AxiosRequest.get(GET_ROLES);
};

const UpdateUserPassword = (password: string, id: string) => {
  return AxiosRequest.put(UPDATE_USER_PASSWORD.replace(":id", id), {
    password: password,
  });
};

const UpdateDefaultFacility = (payload: { facilityId: number | string }) => {
  return AxiosRequest.put(UPDATE_DEFAULT_FACILITY, payload)
}

const CheckDataRetention = () => {
  return AxiosRequest.get(DATA_RETENTION_CHECK);
};

const SubmitDataRetentionChoice = (choice: "keep" | "delete") => {
  return AxiosRequest.post(DATA_RETENTION_CHOICE, { choice });
};

export {
  AddUser,
  GetAllUsersList,
  SingleUser,
  UpdateUser,
  DeleteUser,
  UserRoles,
  UpdateUserPassword,
  UpdateDefaultFacility,
  CheckDataRetention,
  SubmitDataRetentionChoice,
};
